// src/features/medicine-inventory/index.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { InventoryProvider } from './context/InventoryContext';
import { useInventory } from './hooks/useInventory'; // This will now work
import LoadingSpinner from './components/common/LoadingSpinner';
import Navbar from './components/common/Navbar';
import Sidebar from './components/common/Sidebar';
import Dashboard from './pages/Dashboard';
import Categories from './pages/Categories';
import Medicines from './pages/Medicines';
import StockMovements from './pages/StockMovements';
import MedicineIssue from './pages/MedicineIssue';
import MedicinePurchase from './pages/MedicinePurchase';

// Layout component to wrap all pages
// const Layout = ({ children }) => {
//   return (
//     <div className="min-h-screen bg-gray-50">
//       <Navbar />
//       <div className="flex">
//         <Sidebar />
//         <main className="flex-1 p-6">
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// };

// Main feature component with loading handling
const MedicineInventoryFeature = () => {
  return (
    <InventoryProvider>
      <InventoryContent />
    </InventoryProvider>
  );
};

// Content component that uses the context
const InventoryContent = () => {
  const { loading, error } = useInventory();

  if (loading) {
    return (
      // <Layout>
        <LoadingSpinner />
      //</Layout>
    );
  }

  if (error) {
    return (
      // <Layout>
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded relative" role="alert">
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">{error}</span>
        </div>
     // </Layout>
    );
  }

  return (
    //<Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/medicines" element={<Medicines />} />
        <Route path="/stock-movements" element={<StockMovements />} />
        <Route path="/issue-medicines" element={<MedicineIssue />} />
        <Route path="/purchase-medicines" element={<MedicinePurchase />} />
        <Route path="*" element={<Navigate to="/inventory" replace />} />
      </Routes>
    //</Layout>
  );
};

// Export components for external use
export { useInventory } from './hooks/useInventory';
export { InventoryProvider } from './context/InventoryContext';
export * from './utils/helpers';

export default MedicineInventoryFeature;